import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';
import '../styles/Notification.css';

const Notification = ({ notification }) => {
  return (
    <div className={`notification ${notification.type}`}>
      {notification.type === 'success' ? <CheckCircle size={20} /> : <AlertCircle size={20} />}
      <span className="notification-message">{notification.message}</span>
    </div>
  );
};

export default Notification;